import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContractorStaffComponent } from './component/contractor-staff/contractor-staff.component';
import { ContractorContainerComponent } from './container/contractor-container/contractor-container.component';

const routes: Routes = [
	{ path: 'contractor', component: ContractorContainerComponent },
	{ path: 'seismiccontractorstaff', component: ContractorStaffComponent }	
];

@NgModule({
	imports: [ RouterModule.forChild(routes) ],
	exports: [ RouterModule ]
})

export class ContractorRoutingModule {}